export function initGoogleTagManager(gtmId: string) {
  window.dataLayer = window.dataLayer || [];

  window.gtag = function () {
    window.dataLayer.push(arguments);
  };

  window.gtag("consent", "default", {
    analytics_storage: "denied",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    wait_for_update: 500,
  });

  const hostname = window.location.hostname;
  if (!hostname.startsWith("cadastro.ivi")) return;

  loadGTM(gtmId);
}

export function loadGTM(gtmId: string, dataLayerName = "dataLayer") {
  if (!gtmId) return;

  if (window.gtmBlocked) return;

  if (document.getElementById("gtm-script")) return;

  (function (w: Window & { [key: string]: any }, d: Document, s: string, l: string, i: string) {
    w[l] = w[l] || [];
    w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });

    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s) as HTMLScriptElement;
    const dl = l !== "dataLayer" ? "&l=" + l : "";

    j.id = "gtm-script";
    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;

    f?.parentNode?.insertBefore(j, f);
  })(window, document, "script", dataLayerName, gtmId);
}
